import useLang, { Lang } from "hooks/useLang";

export default function LanguageToggler({
  className = "bg-white",
  height,
  width,
}) {
  const { currentLang, handleLangChange, isArabic } = useLang();

  return (
    <div
      className={
        "relative flex items-center justify-between rounded-full p-1 w-fit gap-1 " +
          className || ""
      }
      dir={"ltr"}
    >
      {/* Background slider that moves based on selected language */}
      <div
        className={`absolute rounded-full bg-brand-base-primary transition-all duration-300 ease-in-out ${
          !isArabic ? "left-[0.25rem]" : "right-[0.25rem]"
        }`}
        style={{ height: height ?? "1.75rem", width: width ?? "1.75rem" }}
      />

      {Object.keys(Lang).map((lang) => {
        const langObj = Lang[lang];
        return (
          <button
            key={langObj.code}
            onClick={() => handleLangChange(langObj)}
            className={`z-10 rounded-full flex items-center justify-center font-bold transition-colors text-10x ${
              currentLang === langObj.code ? "text-white" : "text-gray-500"
            }`}
            style={{ height: height ?? "1.75rem", width: width ?? "1.75rem" }}
          >
            {langObj.code}
          </button>
        );
      })}
    </div>
  );
}
